import { Component, OnInit } from '@angular/core';
import { Painting } from 'src/app/models/painting.model';
import { PaintingService } from 'src/app/services/painting.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-painting',
  templateUrl: './painting.component.html',
  styleUrls: ['./painting.component.scss'],
})
export class PaintingComponent implements OnInit {
  
  painting: Painting[]
  id: number;
  

  constructor(
    private _paintingService: PaintingService,
    private _route: ActivatedRoute,
  
  ) {}

  ngOnInit(): void {
    this.id = this._route.snapshot.params['id'];
    this._paintingService
      .getById(this.id)
      .subscribe((data) => (this.painting = data));
  }
}
